import { CSSObject } from "styled-components";
import { vfxTheme } from "../Theme/theme";

interface ButtonStyles {
    formContainer: CSSObject;
    toggle: CSSObject;
    inActiveToggle: CSSObject;
}

const useButtonStyles = (): ButtonStyles => {
        return {
        formContainer: {
            marginBottom:"auto",
            marginTop:"auto",
            zIndex: 5, 
        },
        toggle: {
            backgroundColor: vfxTheme.palette.primary.main,
            color: vfxTheme.palette.background.default,
        },
        inActiveToggle: {
            color: vfxTheme.palette.background.default,
        }
    };
};

export default useButtonStyles;
